import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier-invoice',
  templateUrl: './supplier-invoice.component.html',
  styleUrls: ['./supplier-invoice.component.css']
})
export class SupplierInvoiceComponent implements OnInit {

  public menu_item_id = '18';
  public add_auth;

  item_search_obj = {
    'placeholder': 'اسم الصنف', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no', 'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`', 'join_field_list': ['sub_item_no'],
      'join_condition': ' AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `sub_item`.`is_purch` = "1"'
    }]
  };

  private dp = [];
  private dp1 = [];
  supplierList = [];
  cashAcctList = [];
  bankAcctList = [];
  cost_centers = [];
  units = [];
  sub_item_unit = [];
  taxes = [];
  branches = [];
  store_list = [];
  //stock_no;
  supplier_name: string;
  mobile: string;
  no = '';
  type = '';
  exp_acct = '0';

  toDelete = [];
  //toUpdate = [];

  total_entered = '';
  assets = [];

  model = {
    'invoice_date_d': new Date(), 'final_total': '', 'payment_date_d': new Date(), 'receipt_date_d': new Date(),
    'cash_acct_number': '0', 'bank_acct_number': '0', 'asset': '', 'item_discount': '0', 'final_discount': '',
    'inv_discount': '', 'old_final_total': 0, 'has_voucher': 0, 'is_cc': '0'
  };

  supplier_inv_model = {
    'table_name': 'supplier_invoice', 'supplier_invoice_id': '0', 'supplier_invoice_no': '',
    'supplier_no': '', 'invoice_no': '', 'invoice_date': '0000-00-00', 'amount': '', 
    'tax': '', 'discount': '', 'payment_date': '0000-00-00', 'invoice_type': 'general', 
    'payment_method': '', 'cost_center': '0', 'acct_number': '0', 'received': '1', 
    'receipt_date': '0000-00-00', 'transport_fee': '0', 'is_paid': '1',
    'payment_voucher_no': '', 'purchase_order_no': '', 'comment': '', 'purch_acct': '0',
    'tax_acct': '0', 'from_acct': '0', 'flag': 'new', 'key': 'supplier_invoice_id',
    'trans_acct': '802001', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  displayedColumns = ['check', 'sub_item_name', 'unit_id', 'sub_item_count',
    'unit_price', 'discount', 'tax_no', 'net_price'];

  displayedColumns1 = ['check', 'sub_item_no', 'sub_item_name', 'unit_id', 'store_id',
    'sub_item_count', 'unit_price', 'discount', 'tax_no', 'expiry_date', 'net_price'];

  displayedColumns2 = ['payment_type_name', 'amount'];

  dataSource = new MatTableDataSource(this.dp);
  dataSource2 = new MatTableDataSource(this.dp1);
  @ViewChild(MatSort) sort: MatSort;

  payDialogRef: MatDialogRef<SuppInvPaymentMethodComponent>;

  all_payment_types = [];
  payment_list = [];
  transAcctList = [];
  print_type;
  supplierDetail = '';
  cashDetail = '';
  bankDetail = '';
  saveClicked = false;
  // bankList = [];

  @HostListener('window:keydown', ['$event'])
  handleKeyDownEvent(event: KeyboardEvent) {
    if (event.key == "F7")
      this.saveInvoice('print');

    if (event.key == "F8")
      this.saveInvoice('save_only');
  }

  One_Item_Msg; Count_Price_Msg; Supplier_Msg; Supplier_Placeholder;
  Del_Line_Msg; Pay_Msg; Bank_Acct_Msg; Inv_No_Msg; Acct_Placeholder;
  Casher_Msg; Success_Msg; Error_Msg; Main_Item_Name;
  Invoice_No_Msg; Expiry_Date_Msg; Inv_Type_Msg;
  Inv_No_Exist_Msg; Not_Counter_Msg; No_Store_Msg;
  Supplier_Cc_Msg; No_Item_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    private route: ActivatedRoute, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_Bank['placeholder'] = this.Acct_Placeholder;
    // this.search_acct['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Pay_Msg').subscribe((res: string) => {
      this.Pay_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Count_Price_Msg').subscribe((res: string) => {
      this.Count_Price_Msg = res;
    });

    translate.get('Supplier_Msg').subscribe((res: string) => {
      this.Supplier_Msg = res;
    });

    translate.get('Supplier_Cc_Msg').subscribe((res: string) => {
      this.Supplier_Cc_Msg = res;
    });

    translate.get('Supplier_Placeholder').subscribe((res: string) => {
      this.Supplier_Placeholder = res;
    });
    // this.search_obj['placeholder'] = this.Supplier_Placeholder

    translate.get('Main_Item_Name').subscribe((res: string) => {
      this.Main_Item_Name = res;
    });
    this.item_search_obj['placeholder'] = this.Main_Item_Name;

    translate.get('Invoice_No_Msg').subscribe((res: string) => {
      this.Invoice_No_Msg = res;
    });

    translate.get('No_Store_Msg').subscribe((res: string) => {
      this.No_Store_Msg = res;
    });

    translate.get('Expiry_Date_Msg').subscribe((res: string) => {
      this.Expiry_Date_Msg = res;
    });

    translate.get('Casher_Msg').subscribe((res: string) => {
      this.Casher_Msg = res;
    });

    translate.get('Del_Line_Msg').subscribe((res: string) => {
      this.Del_Line_Msg = res;
    });

    translate.get('Inv_Type_Msg').subscribe((res: string) => {
      this.Inv_Type_Msg = res;
    });

    translate.get('Inv_No_Exist_Msg').subscribe((res: string) => {
      this.Inv_No_Exist_Msg = res;
    });

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });
    
    translate.get('No_Item_Name_Msg').subscribe((res: string) => {
      this.No_Item_Name_Msg = res;
    });
  }

  ngOnInit() {
    let query, obj, selObj;

    (document.getElementById('received') as HTMLInputElement).checked = (this.supplier_inv_model['received'] == '1');
    
    this.toDelete = [];
    this.print_type = this.utils.getParamValue('print_type');

    // get leaf supplier accts
    let branch_list = [{ 'branch_id': this.supplier_inv_model['branch_id'] }, { 'branch_id': '0' }];
    let parent_acct = this.applicationConstants.main_acct_config['supplier'];
    obj = {
      cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true,
      check_cc: false, type: 'supplier', branch_list: branch_list
    };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.supplierList = data.data['list'];
      });

    // get leaf cash accts
    parent_acct = this.applicationConstants.main_acct_config['cash'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cashAcctList = data.data['list'];
      });

    // get leaf bank accts
    parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    // get leaf expenses accts
    parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.exp_acct = data.data['list'][0]['acct_number'];
      });

    // get leaf transport income accts
    parent_acct = this.applicationConstants.main_acct_config['transport_expenses'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.transAcctList = data.data['list'];
      });

    // ******************* Get All Payment Types to send array to supp_inv_payment_method component ******************* //
    query = this.queryList.all_paymentType;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.all_payment_types = data.data['list'];
        if (this.all_payment_types.length == 5)
          this.all_payment_types.splice(4, 1);

      });

    query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });

    query = this.queryList.all_unit;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.units = data.data['list'];

        selObj = { 'unit_id': '0', 'unit_name': 'اختر', 'unit_name_en': 'Select' };
        this.units.unshift(selObj);
        //(document.getElementById(type + 'unit_id_1') as HTMLInputElement).value = '0';
      });

    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.taxes = data.data['list'];

        selObj = { 'acct_number': '', 'tax_name_ar': 'اختر', 'tax_name_en': 'Select' };
        this.taxes.unshift(selObj);
        //(document.getElementById(type + 'tax_no_1') as HTMLInputElement).value = '0';
      });

    // Get branch list
    // query = this.queryList.all_branch;
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.branches = data.data['list'];
    //     //(document.getElementById('brach_id_1') as HTMLInputElement).value = '1';
    //   });

    // Get store list
    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
      " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
      "' AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.store_list = data.data['list'];
      });

    let default_payment_type = this.utils.getParamValue('default_payment_type');
    if (default_payment_type != undefined || default_payment_type != '') {
      query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" +
        default_payment_type + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.payment_list = data.data['list'];
        });
    }
    // query = "SELECT * FROM `param` WHERE `status` = '1' AND `name` = 'default_payment_type'";
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     let default_payment_type = data.data['list']['0']['value'];

    //     if (default_payment_type != undefined || default_payment_type != '') {
    //       let query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" + default_payment_type + "'";
    //       let obj = { cmd: 'getList', query: query };
    //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();
    //           this.payment_list = data.data['list'];
    //         });
    //     }
    //   });

    // query = this.queryList.all_bank;
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.bankList = data.data['list'];

    //     selObj = {
    //       'account_id': '0', 'bank_acct_number': '', 'acct_number': '0', 'account_name': 'اختر',
    //       'account_name_en': 'Select'
    //     };
    //     this.bankList.unshift(selObj);
    //   });

    this.route.params.subscribe(params => {
      /////////////////////////////////  Edit /////////////////////////////////
      if (params['no'] != undefined) {
        if (params['type'] != 'export_pur_order') {
          this.no = params['no'];
          this.type = params['type'];
          this.getSupplierInvoice();
        }
        else {
          this.no = params['no'];
          this.exportPurchaseOrder();
        }
      }
      else {
        this.dp.push({
          'id': 1, 'sub_item_no': '', 'sub_item_number': '', 'sub_item_name': '', 'unit_id': '0',
          'unit_no': '0', 'count': '', 'price': '', 'total_price': '', 'discount': '', 'tax_no': '',
          'tax_amount': '', 'net_price': '', 'store_id': '0', 'expiry_date': '', 'stock_no': '0', 'flag': 'new',
          'supplier_invoice_item_id': '0', 'key': 'supplier_invoice_item_id', 'primary_sub_item_number': '0',
          'expense_acct_no': this.exp_acct, 'primary_quantity': '0', 'sub_item_unit': [],
          'stock_id': '0', 'baseline_id': '0'
        });
      }
    });

    // check add authorization
    if (this.no == '')
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    else
      this.add_auth = true;
  }

  onChangeSupplier = function (acct_number: string) {
    this.supplier_inv_model['supplier_no'] = acct_number;

    if (this.supplier_inv_model['supplier_no'] != '') {
      this.supplierList.forEach(element => {
        if (element.acct_number == this.supplier_inv_model['supplier_no']) {
          this.model['is_cc'] = element.is_cc;
          return;
        }
      });
    }
    console.log(this.model['is_cc']);

    // *******************  In Edit Mode change flag for default payment method to update ******************* //
    if (this.supplier_inv_model['flag'] == 'update') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'credit') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
    console.log(this.all_payment_types);
  }

  onChangeCashAcct = function (acct_number: string) {
    this.model['cash_acct_number'] = acct_number;

    // *******************  In Edit Mode change flag for cash payment method to update ******************* //
    if (this.supplier_inv_model['flag'] == 'update') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'cash') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  onChangeBankAcct = function (acct_number: string) {
    this.model['bank_acct_number'] = acct_number;

    // *******************  In Edit Mode, change flag for bank or visa payment method to update if there is ******************* //
    if (this.supplier_inv_model['flag'] == 'update') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  onChangeBank = function (search_result: object) {
    this.model['bank_acct_number'] = search_result['no'];

    // *******************  In Edit Mode, change flag for bank or visa payment method to update if there is ******************* //
    if (this.supplier_inv_model['flag'] == 'update') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  changeInvType(event) {
    // this.count = 1;
    this.dp = [{
      'id': 1, 'sub_item_no': '', 'sub_item_number': '', 'sub_item_name': '', 'unit_id': '0', 'unit_no': '0',
      'count': '', 'price': '', 'total_price': '', 'discount': '', 'tax_no': '', 'tax_amount': '', 'net_price': '',
      'store_id': '0', 'expiry_date': '', 'stock_no': '', 'flag': 'new', 'supplier_invoice_item_id': '0',
      'key': 'supplier_invoice_item_id', 'primary_sub_item_number': '0', 'primary_quantity': '0', 'sub_item_unit': [],
      'stock_id': '0', 'baseline_id': '0'
    }];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;

    this.supplier_inv_model['amount'] = '';
    this.supplier_inv_model['discount'] = '';
    this.supplier_inv_model['tax'] = '';
    this.model['final_total'] = '';
    this.model['inv_discount'] = '';

    this.dp1 = [];
    this.dataSource2 = new MatTableDataSource(this.dp1);
    this.dataSource2.sort = this.sort;
    this.total_entered = '0';
  }

  onChangeItem = function (search_result: object) {
    let row_id = search_result['row_id'];
    console.log(row_id);
    let sub_item_no;
    if (search_result['no'] != '') {
      sub_item_no = search_result['no'];
      console.log(sub_item_no);
      this.getSubItem(row_id, sub_item_no);
    }
  }

  getSupplierInvoice() {
    (document.getElementById('inv_type1') as HTMLInputElement).disabled = true;
    (document.getElementById('inv_type2') as HTMLInputElement).disabled = true;

    /////////////////////////////////  Get Supplier Invoice Detail /////////////////////////////////
    let obj;
    let query = "SELECT `supplier_invoice`.* FROM `supplier_invoice` WHERE `supplier_invoice`.`invoice_no` = '" +
      this.no + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let invoice_detail = data.data['list'][0];

        this.supplier_inv_model['supplier_invoice_no'] = invoice_detail['supplier_invoice_no'];
        this.supplier_inv_model['supplier_invoice_id'] = invoice_detail['supplier_invoice_id'];
        this.supplier_inv_model['invoice_no'] = invoice_detail['invoice_no'];
        this.supplier_inv_model['cost_center'] = invoice_detail['cost_center'];
        this.model['invoice_date_d'] = new Date(invoice_detail['invoice_date']);
        this.supplier_inv_model['invoice_date'] = invoice_detail['invoice_date'];
        this.model['payment_date_d'] = new Date(invoice_detail['payment_date']);
        this.supplier_inv_model['payment_date'] = invoice_detail['payment_date'];
        this.supplier_inv_model['invoice_type'] = invoice_detail['invoice_type'];
        this.supplier_inv_model['supplier_no'] = invoice_detail['supplier_no'];
        this.supplier_inv_model['amount'] = invoice_detail['amount'];
        this.supplier_inv_model['discount'] = invoice_detail['discount'];
        this.supplier_inv_model['tax'] = invoice_detail['tax'];
        this.model['inv_discount'] = '0';
        this.model['final_total'] = (Number(invoice_detail['amount']) + Number(invoice_detail['tax']) -
          Number(invoice_detail['discount']) + Number(invoice_detail['transport_fee'])).toFixed(2);
        this.total_entered = this.model['final_total'];
        this.model['old_final_total'] = Number(this.model['final_total']);
        this.supplier_inv_model['received'] = invoice_detail['received'];
        this.supplier_inv_model['receipt_date'] = invoice_detail['receipt_date'];
        this.model['receipt_date_d'] = new Date(invoice_detail['receipt_date']);
        this.supplier_inv_model['transport_fee'] = invoice_detail['transport_fee'];
        this.supplier_inv_model['comment'] = invoice_detail['comment'];
        this.supplier_inv_model['flag'] = 'update';
        this.supplier_inv_model['branch_id'] = invoice_detail['branch_id'];
        (document.getElementById('received') as HTMLInputElement).checked = (this.supplier_inv_model['received'] == '1');

        /////////////////////////////////  Get Supplier Detail /////////////////////////////////

        query = "SELECT * FROM `supplier` WHERE `acct_number` = '" + invoice_detail['supplier_no'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let supDetail = data.data['list'][0];
            this.supplierDetail = supDetail['acct_number'] + "-" + supDetail['supplier_name'] + "-" +
              supDetail['supplier_name_en'] + "-" + supDetail['mobile'];
            this.model['is_cc'] = supDetail['is_account'];

            // (document.getElementById('search_value_0') as HTMLInputElement).value = supDetail['acct_number'] +
            //   "-" + supDetail['supplier_name'] + "-" + supDetail['supplier_name_en'] + "-" + supDetail['mobile'];
          });


        // check if there is payment voucher for this invoice
        query = "SELECT `payment_voucher`.`payment_voucher_no`, `payment_voucher`.`paid` FROM " +
          "`payment_voucher`, `payment_voucher_invoice` WHERE `payment_voucher_invoice`.`invoice_no` = '" +
          this.no + "' AND `payment_voucher_invoice`.`status` != '0' AND " +
          "`payment_voucher_invoice`.`payment_voucher_no` = `payment_voucher`.`payment_voucher_no`";

        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.model['has_voucher'] = (data.data['list'].length > 0 ? 1 : 0);
          });

        /////////////////////////////////  Get Supplier Invoice Type for Old invoice /////////////////////////////////
        if (this.supplier_inv_model['invoice_type'] == '') {
          query = "SELECT `sub_item_number` FROM `supplier_invoice_item` WHERE `invoice_no` = '" + this.no + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              if (data.data['list'][0]['sub_item_number'] == '' || data.data['list'][0]['sub_item_number'] == '0')
                this.supplier_inv_model['invoice_type'] = 'general';
              else
                this.supplier_inv_model['invoice_type'] = 'stock';

              console.log(this.supplier_inv_model['invoice_type']);
            });
        }

        //get store list:

        query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
          " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
          " `branch_auth`.`branch_id` = '" + invoice_detail['branch_id'] +
          "' AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
          " AND `branch_auth`.`store_id` = `store`.`store_id`";

        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.store_list = data.data['list'];
          });

        /////////////////////////////////  Get Invoice Item & Stock Detail /////////////////////////////////

        obj = { cmd: 'getInvoiceItem', type: 'supplier_invoice', invoice_no: this.no };
        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.dp = data.status['msg'];
            this.dataSource = new MatTableDataSource(this.dp);
            this.dataSource.sort = this.sort;
            console.log(this.dp);
          });

      });


    /////////////////////////////////  Get Payment Method /////////////////////////////////

    query = "SELECT `supp_inv_payment_method`.*, `payment_type`.*, 'update' AS 'flag'," +
      " `supp_inv_payment_method`.`supp_inv_payment_method_id` AS `inv_payment_method_id`," +
      " 'supp_inv_payment_method_id' AS 'key' FROM `supp_inv_payment_method`, `payment_type`" +
      " WHERE `supp_inv_payment_method`.`status` = '1' AND `payment_type`.`payment_type_id` = `supp_inv_payment_method`.`payment_type_id` AND " +
      "`supp_inv_payment_method`.`invoice_no` = '" + this.no + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp1 = data.data['list'];
        this.dataSource2 = new MatTableDataSource(this.dp1);
        this.dataSource2.sort = this.sort;
        // console.log(this.dp1);
        let cash_existed = false;
        let credit_existed = false;
        let bank_existed = false;

        let query1 = "";
        this.dp1.forEach(element => {
          if (element.payment_type_key == 'cash') {
            cash_existed = true;
            this.model['cash_acct_number'] = element.acct_number;

            query1 = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + element.acct_number + "'";
            obj = { cmd: 'getList', query: query1 };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_info = data.data['list'][0];
                this.cashDetail = acct_info.acct_number + ' - ' + acct_info.sub_acct_name + ' - ' +
                  acct_info.sub_acct_name_en + ' - ' + acct_info.emp_no;

                // (document.getElementById('search_value_10000') as HTMLInputElement).value = acct_info.acct_number + 
                //   ' - ' + acct_info.sub_acct_name + ' - ' + acct_info.sub_acct_name_en + ' - ' + acct_info.emp_no;

              });
            // (document.getElementById('search_value_10000') as HTMLInputElement).value = element.acct_number; 
          }
          if (element.payment_type_key == 'credit') {
            credit_existed = true;
          }
          else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {
            bank_existed = true;
            this.model['bank_acct_number'] = element.acct_number;
            query1 = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + element.acct_number + "'";
            obj = { cmd: 'getList', query: query1 };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_info = data.data['list'][0];
                this.bankDetail = acct_info.acct_number + ' - ' + acct_info.sub_acct_name + ' - ' +
                  acct_info.sub_acct_name_en + ' - ' + acct_info.emp_no;

                // (document.getElementById('search_value_20000') as HTMLInputElement).value = acct_info.bank_acct_number + 
                //   ' - ' + acct_info.acct_number + ' - ' + acct_info.account_name + ' - ' + acct_info.account_name_en;
              });

            // (document.getElementById('search_value_20000') as HTMLInputElement).value = element.acct_number;

          }

          // ******************* Based on the supplier invoice payment method fill amount, inv_payment_method_id and falg in All Payment Types array ******************* //
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == element.payment_type_id) {
              element1.amount = element.amount;
              element1.inv_payment_method_id = element.inv_payment_method_id;
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.inv_payment_method_id = '';
            }
            element1.flag = '';
          });
        });

        if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account') {
          document.getElementById('tr_cash').style.display = (cash_existed ? '' : 'none');
          document.getElementById('tr_cash2').style.display = (cash_existed ? '' : 'none');
        }
        document.getElementById('tr_payment_date').style.display = (credit_existed ? 'table-row' : 'none');
        document.getElementById('tr_bank_acct').style.display = (bank_existed ? 'table-row' : 'none');
        document.getElementById('tr_bank_acct2').style.display = (bank_existed ? 'table-row' : 'none');
        this.supplier_inv_model['is_paid'] = (credit_existed ? '0' : '1');
        console.log(this.all_payment_types);
      });


    if (this.type == 'copy') {
      this.supplier_inv_model['supplier_invoice_id'] = '0';
      this.supplier_inv_model['invoice_no'] = '';
      this.model['invoice_date_d'] = new Date();
      this.supplier_inv_model['flag'] = 'new';
    }
  }




  exportPurchaseOrder() {

    ///////////////////////////////// Get Purchase Order Detail /////////////////////////////////
    let obj;
    let query = "SELECT `purchase_order`.* FROM `purchase_order` WHERE `purchase_order`.`purchase_order_no` = '" +
      this.no + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let invoice_detail = data.data['list'][0];

        //this.supplier_inv_model['invoice_type'] = 'stock';
        this.supplier_inv_model['supplier_no'] = invoice_detail['supplier_no'];
        this.supplier_inv_model['amount'] = invoice_detail['total'];
        this.supplier_inv_model['discount'] = invoice_detail['discount'];
        this.supplier_inv_model['tax'] = invoice_detail['tax'];
        this.model['inv_discount'] = '0';
        this.model['final_total'] = (Number(invoice_detail['total']) + Number(invoice_detail['tax']) -
          Number(invoice_detail['discount']) + Number(invoice_detail['transport_fee'])).toFixed(2);
        this.total_entered = this.model['final_total'];
        this.supplier_inv_model['transport_fee'] = invoice_detail['transport_fee'];
        this.supplier_inv_model['purchase_order_no'] = invoice_detail['purchase_order_no'];
        this.supplier_inv_model['comment'] = (invoice_detail['comment'] != null ? invoice_detail['comment'] : '');
        this.supplier_inv_model['purch_acct'] = this.exp_acct;

        this.supplier_inv_model['flag'] = 'new';

        /////////////////////////////////  Get Supplier Detail /////////////////////////////////

        query = "SELECT * FROM `supplier` WHERE `acct_number` = '" + invoice_detail['supplier_no'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let supDetail = data.data['list'][0];
            this.supplierDetail = supDetail['acct_number'] + "-" + supDetail['supplier_name'] + "-" +
              supDetail['supplier_name_en'] + "-" + supDetail['mobile'];

            this.model['is_cc'] = supDetail['is_account'];

            // (document.getElementById('search_value_0') as HTMLInputElement).value = supDetail['acct_number'] +
            //   "-" + supDetail['supplier_name'] + "-" + supDetail['supplier_name_en'] + "-" + supDetail['mobile'];
          });

        /////////////////////////////////  Get Invoice Item  /////////////////////////////////

        obj = { cmd: 'getInvoiceItem', type: 'purchase_order', invoice_no: this.no };
        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.dp = data.status['msg'];
            if (this.dp['0']['sub_item_no'] == '')
              this.supplier_inv_model['invoice_type'] = 'general';
            else
              this.supplier_inv_model['invoice_type'] = 'stock';
            this.dataSource = new MatTableDataSource(this.dp);
            this.dataSource.sort = this.sort;
            console.log(this.dp);
            // this.dp.forEach(element => {
            //   (document.getElementById('search_value_' + element.id) as HTMLInputElement).value = element.sub_item_name;
            // });
          });

        /////////////////////////////////    /////////////////////////////////
        this.changeFinalTotal();
      });

  }




  // searchSupplier() {
  //   this.searchDialogRef = this.dialog.open(SearchSupplierComponent, {
  //     hasBackdrop: false,
  //   });
  //   this.searchDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if (result != undefined) {
  //         this.supplier_inv_model['supplier_no'] = result['supplier_no'];
  //         this.supplier_name = result['supplier_name'];
  //         this.mobile = result['mobile'];

  //       }
  //     });
  // }

  addLine() {
    if (this.supplier_inv_model['invoice_type'] != '') {
      // this.count++;
      let next_id = 1;
      if (this.dp.length > 0)
        next_id = Number(this.dp[this.dp.length - 1]['id']) + 1;

      this.dp.push({
        'id': next_id, 'sub_item_no': '', 'sub_item_number': '', 'sub_item_name': '', 'unit_id': '0',
        'unit_no': '0', 'count': '', 'price': '', 'total_price': '', 'discount': '', 'tax_no': '',
        'tax_amount': '', 'net_price': '', 'store_id': '0', 'expiry_date': '', 'stock_no': '0', 'flag': 'new',
        'supplier_invoice_item_id': '0', 'key': 'supplier_invoice_item_id', 'primary_sub_item_number': '0',
        'expense_acct_no': this.exp_acct, 'primary_quantity': '0', 'sub_item_unit': [],
        'stock_id': '0', 'baseline_id': '0'
      });
      
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
    else
      alert(this.Inv_Type_Msg);
  }

  delLine() {
    let count = 0;
    for (let index = (this.dp.length - 1); index >= 0; index--) {
      let id = this.dp[index]['id'];
      let type = this.supplier_inv_model['invoice_type'] + '_';

      let check = document.getElementById(type + 'check_' + id) as HTMLInputElement;
      let supplier_invoice_item_id = this.dp[index]['supplier_invoice_item_id']; 
      
      if (check.checked == true) {

        if (supplier_invoice_item_id != undefined && supplier_invoice_item_id != '' && supplier_invoice_item_id != '0') {
          this.toDelete.push(this.dp[index]);
        }

        this.dp.splice(index, 1);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        count++;

        let total_price, net_total_price, tax_amount = 0, total = 0, tax = 0, discount = 0;

        this.dp.forEach(element => {
          console.log(element);
          total_price = Number(element.price) * Number(element.count);
          net_total_price = total_price - Number(element.discount);
          total += total_price;
          discount += Number(element.discount);
          tax_amount = 0;

          if (element.tax_no != '') {
            this.taxes.forEach(element1 => {
              if (element1.acct_number == element.tax_no) {
                if (element1.tax_perc != 0)
                  tax_amount = net_total_price * (Number(element1.tax_perc) / 100);
                else if (element1.tax_amount != 0)
                  tax_amount = element1.tax_amount;
                return false;
              }
            });
          }

          net_total_price += tax_amount;
          tax += tax_amount;
        });

        this.supplier_inv_model['amount'] = total.toFixed(2);
        this.supplier_inv_model['discount'] = discount.toFixed(2);
        this.supplier_inv_model['tax'] = tax.toFixed(2);
        this.model['final_total'] = (Number(total) + Number(tax) - Number(discount)).toFixed(2);
        this.model['final_discount'] = discount.toFixed(2);
      }
    }

    if (count == 0)
      alert(this.Del_Line_Msg);
    else
      this.changeFinalTotal();
  }

  getSubItem(row_id, sub_item_no) {

    let obj = { cmd: 'getSubItemByBarcode', sub_item_no: sub_item_no, is_purch: '1', store_id: '0' };
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') {
          alert(data.status['msg']);
        }
        else {
          let sub_item = data.status['msg'][0];
          console.log(sub_item);

          let dp_index = this.getDPIndex(row_id);

          this.dp[dp_index]['sub_item_no'] = sub_item.sub_item_no;
          this.dp[dp_index]['sub_item_number'] = sub_item.sub_item_number;
          this.dp[dp_index]['sub_item_name'] = sub_item.main_item_name + '-' + sub_item.main_item_name_en;
          this.dp[dp_index]['unit_id'] = sub_item.unit_id;
          this.dp[dp_index]['unit_no'] = sub_item.unit_no;
          this.dp[dp_index]['is_expire'] = sub_item.is_expire;
          this.dp[dp_index]['tax_no'] = sub_item.def_tax_acct;
          this.dp[dp_index]['primary_sub_item_number'] = sub_item.primary_sub_item_number;
          this.dp[dp_index]['primary_quantity'] = sub_item.primary_quantity;
          this.dp[dp_index]['sub_item_unit'] = sub_item.sub_item_unit;
          this.dp[dp_index]['expense_acct_no'] = sub_item.expense_acct_no;
          this.dp[dp_index]['def_tax_acct'] = sub_item.def_tax_acct;
        }
      });
  }

  getDPIndex(row_id) {
    let index = 0
    for (index = 0; index < this.dp.length; index++) {
      let element = this.dp[index];
      if (element.id == row_id)
        break;
    }
    return index;
  }

  changeUnit(event) {
    let id = event.srcElement.id;
    console.log(id);
    let row_id = id.substring(id.lastIndexOf('_') + 1);
    let unit_no = event.srcElement.value;
    let dp_index = this.getDPIndex(row_id);
    let sub_item_unit = this.dp[dp_index]['sub_item_unit'];

    sub_item_unit.forEach(element => {
      if (unit_no == element.unit_no) {
        this.dp[dp_index]['sub_item_no'] = element.sub_item_no;
        this.dp[dp_index]['sub_item_number'] = element.sub_item_number;
        this.dp[dp_index]['unit_id'] = element.unit_id;
        this.dp[dp_index]['unit_no'] = element.unit_no;
        this.dp[dp_index]['primary_quantity'] = element.primary_quantity;
      }
    });
  }

  calculateTotal(event) {
    let id = event.srcElement.id;
    let row_id = id.substring(id.lastIndexOf('_') + 1);
    if (id == 'inv_discount')
      row_id = '1';
    let type = this.supplier_inv_model['invoice_type'] + '_';

    if (isNaN(Number(event.srcElement.value))) {
      event.srcElement.value = String(parseFloat(event.srcElement.value));
    }

    if (isNaN(Number(event.srcElement.value))) {
      event.srcElement.value = '0';
    }

    if (!isNaN(Number(event.srcElement.value))) {

      let dp_index = this.getDPIndex(row_id);
      let sub_item_count = Number((document.getElementById(type + 'sub_item_count_' + row_id) as HTMLInputElement).value);
      this.dp[dp_index]['count'] = sub_item_count;
      let unit_price = Number((document.getElementById(type + 'unit_price_' + row_id) as HTMLInputElement).value);
      this.dp[dp_index]['price'] = unit_price;
      console.log(sub_item_count);

      let total_price = (sub_item_count * unit_price);
      this.dp[dp_index]['total_price'] = total_price.toFixed(2);
      
      let discount = Number((document.getElementById(type + 'discount_' + row_id) as HTMLInputElement).value);
      this.dp[dp_index]['discount'] = discount;

      let net_price = total_price - discount;
      let tax_no = (document.getElementById(type + 'tax_no_' + row_id) as HTMLInputElement).value;
      this.dp[dp_index]['tax_no'] = tax_no;

      let tax_amount = 0;
      if (tax_no != '') {
        this.taxes.forEach(element1 => {
          if (element1.acct_number == tax_no) {
            if (element1.tax_perc != 0)
              tax_amount = net_price * (element1.tax_perc / 100);
            else if (element1.tax_amount != 0)
              tax_amount = element1.tax_amount;
            return false;
          }
        });
      }
      this.dp[dp_index]['tax_amount'] = tax_amount.toFixed(2);

      net_price += tax_amount;
      this.dp[dp_index]['net_price'] = net_price.toFixed(2);

      let net_total_price, total = 0, tax = 0;
      discount = 0;

      this.dp.forEach(element => {
        console.log(element);
        total_price = Number(element.price) * Number(element.count);
        net_total_price = total_price - Number(element.discount);
        total += net_total_price;
        discount += Number(element.discount);
        tax_amount = 0;

        if (element.tax_no != '') {
          this.taxes.forEach(element1 => {
            if (element1.acct_number == element.tax_no) {
              if (element1.tax_perc != 0)
                tax_amount = net_total_price * (Number(element1.tax_perc) / 100);
              else if (element1.tax_amount != 0)
                tax_amount = element1.tax_amount;
              return false;
            }
          });
        }

        net_total_price += tax_amount;
        tax += tax_amount;
      });

      this.supplier_inv_model['amount'] = total.toFixed(2);
      this.supplier_inv_model['discount'] = discount.toFixed(2);
      this.supplier_inv_model['tax'] = tax.toFixed(2);
      console.log("Discount: " + this.supplier_inv_model['discount']);
      
      this.model['final_total'] = (Number(total) + Number(tax)).toFixed(2);
      this.model['final_discount'] = discount.toFixed(2);
      this.model['item_discount'] = this.supplier_inv_model['discount'];
      this.model['final_discount'] = (Number(this.supplier_inv_model['discount']) + Number(this.model['inv_discount'])).toFixed(2);
      
      // this.supplier_inv_model['amount'] = ((Number(this.supplier_inv_model['amount']) - Number(org_total_price)) + total_price).toFixed(2);
      // this.supplier_inv_model['tax'] = ((Number(this.supplier_inv_model['tax']) - Number(org_tax_amount)) + tax_amount).toFixed(2);
      // this.supplier_inv_model['discount'] = ((Number(this.supplier_inv_model['discount']) - Number(org_discount)) + discount).toFixed(2);
      // this.model['final_total'] = ((Number(this.model['final_total']) - Number(org_net_price)) + net_price).toFixed(2);
      
      // if (id == (type + 'discount_' + row_id)) {
        
      //   this.model['item_discount'] = this.supplier_inv_model['discount'];
      //   this.model['final_discount'] = (Number(this.supplier_inv_model['discount']) + Number(this.model['inv_discount'])).toFixed(2);
      // }
      //////////////////////// Taxes after Discount /////////////////////

      if (Number(this.model['inv_discount']) > 0) {
        this.discount();
      }

      this.changeFinalTotal();
    }
    ////////////////////////////////////////////////////////////////
  }

  changeFinalTotal() {
    if (this.supplier_inv_model['total'] != '' && Number(this.supplier_inv_model['total']) != 0) {

      let index;
      if (this.dp1.length == 0 || this.dp1.length > 1) {

        if (this.supplier_inv_model['flag'] == 'update') {
          let existed = false;

          // ******************* in the edit mode, change the payment method to default and change the flag of saved payment method to delete and remove it from array ******************* //
          for (let indx = this.dp1.length - 1; indx >= 0; indx--) {
            existed = false;

            for (index = 0; index < this.payment_list.length; index++) {
              if (this.payment_list[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                existed = true;
                break;
              }
            }

            if (!existed) {
              let flag = this.dp1[indx]['flag'];

              if (flag != 'new') {
                for (index = 0; index < this.all_payment_types.length; index++) {
                  if (this.all_payment_types[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                    this.all_payment_types[index]['amount'] = this.dp1[indx]['amount'];
                    this.all_payment_types[index]['flag'] = 'delete';
                    this.all_payment_types[index]['inv_payment_method_id'] = this.dp1[indx]['inv_payment_method_id'];

                    break;
                  }
                }
              }

              this.dp1.splice(indx, 1);
            }
          }

          // ******************* in the edit mode, after changing the flag of saved payment method to delete and remove it from array. if array is empty, fill it with default payment ******************* //
          if (this.dp1.length == 0) {
            this.dp1 = this.payment_list;
            this.all_payment_types.forEach(element1 => {

              if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
                element1.amount = this.model['final_total'];
                element1.flag = 'new';
                element1.inv_payment_method_id = '';
                return false;
              }
            });
          }
        }
        else {
          // ******************* in the new mode and after filling the array with default payment, change the flag to new ******************* //
          this.dp1 = this.payment_list;
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
              element1.amount = this.model['final_total'];
              element1.flag = 'new';
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.flag = '';
            }

            element1.inv_payment_method_id = '';
          });
        }
      }
      this.dp1[0]['amount'] = this.model['final_total'];

      // ******************* change the flag to new if there is no id and update if there is  ******************* //
      for (index = 0; index < this.all_payment_types.length; index++) {
        if (this.all_payment_types[index]['payment_type_id'] == this.dp1[0]['payment_type_id']) {
          this.all_payment_types[index]['amount'] = this.dp1[0]['amount'];
          console.log(this.dp1[0]['amount']);
          // this.all_payment_types[index]['flag'] = this.dp1[0]['flag'];

          if (this.all_payment_types[index]['inv_payment_method_id'] != '')
            this.all_payment_types[index]['flag'] = 'update';
          else
            this.all_payment_types[index]['flag'] = 'new';

          break;
        }
      }
      this.total_entered = this.model['final_total'];
      
      let is_cash = false;
      let is_credit = false;
      let is_bank = false;

      if (this.dp1[0]['payment_type_key'] == 'cash')
        is_cash = true;
      if (this.dp1[0]['payment_type_key'] == 'credit')
        is_credit = true;
      else if (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa')
        is_bank = true;

      if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account') {
        document.getElementById('tr_cash').style.display = (is_cash ? '' : 'none');
        document.getElementById('tr_cash2').style.display = (is_cash ? '' : 'none');
      }
      document.getElementById('tr_payment_date').style.display = (is_credit ? 'table-row' : 'none');
      document.getElementById('tr_bank_acct').style.display = (is_bank ? 'table-row' : 'none');
      document.getElementById('tr_bank_acct2').style.display = (is_bank ? 'table-row' : 'none');
      this.supplier_inv_model['is_paid'] = (is_credit ? '0' : '1');

      this.dataSource2 = new MatTableDataSource(this.dp1);
      this.dataSource2.sort = this.sort;

      console.log(this.supplier_inv_model['is_paid']);
    }
  }

  discount() {
    if (isNaN(Number(this.model['inv_discount']))) {
      this.model['inv_discount'] = String(parseFloat(this.model['inv_discount']));
    }

    if (isNaN(Number(this.model['inv_discount']))) {
      this.model['inv_discount'] = '0';
    }

    if (!isNaN(Number(this.model['inv_discount'])) && this.dp1.length > 0) {
      let final_discount = (Number(this.model['item_discount']) + Number(this.model['inv_discount'])).toFixed(2);
      let total = (Number(this.supplier_inv_model['amount']) - Number(this.model['inv_discount'])).toFixed(2);

      //////////////////////// Taxes /////////////////////
      let type = this.supplier_inv_model['invoice_type'] + '_';
      let tax_no = (document.getElementById(type + 'tax_no_1') as HTMLInputElement).value;
      let tax_amount = 0;
      if (tax_no != '') {
        this.taxes.forEach(element1 => {
          if (element1.acct_number == tax_no) {
            if (element1.tax_perc != 0)
              tax_amount = Number(total) * (element1.tax_perc / 100);
            else if (element1.tax_amount != 0)
              tax_amount = element1.tax_amount;
            return false;
          }
        });
      }
      
      this.supplier_inv_model['tax'] = tax_amount.toFixed(2);
      ////////////////////////////////////////////////////

      this.model['final_total'] = (Number(total) + Number(this.supplier_inv_model['tax']) + Number(this.supplier_inv_model['transport_fee'])).toFixed(2);
      this.supplier_inv_model['discount'] = final_discount;
      this.model['final_discount'] = final_discount;
      this.dp1[0]['amount'] = this.model['final_total'];
      this.total_entered = this.model['final_total'];

      this.changeFinalTotal();
    }
  }

  changeTransportFee() {
    if (isNaN(Number(this.supplier_inv_model['transport_fee']))) {
      this.supplier_inv_model['transport_fee'] = String(parseFloat(this.supplier_inv_model['transport_fee']));
    }

    if (isNaN(Number(this.supplier_inv_model['transport_fee']))) {
      this.supplier_inv_model['transport_fee'] = '0';
    }

    if (!isNaN(Number(this.supplier_inv_model['transport_fee'])) && this.dp1.length > 0) {
      this.model['final_total'] = (Number(this.supplier_inv_model['amount']) -
        (Number(this.model['item_discount']) + Number(this.model['inv_discount'])) +
        Number(this.supplier_inv_model['tax']) + Number(this.supplier_inv_model['transport_fee'])).toFixed(2);

      if (Number(this.supplier_inv_model['transport_fee']) > 0)
        this.supplier_inv_model['trans_acct'] = this.transAcctList[0]['acct_number'];
      else
        this.supplier_inv_model['trans_acct'] = '0';

      this.dp1[0]['amount'] = this.model['final_total'];
      this.total_entered = this.model['final_total'];
      this.changeFinalTotal();
    }
  }

  changeReceive() {
    this.supplier_inv_model['received'] = ((document.getElementById('received') as HTMLInputElement).checked ? '1' : '2');
  }

  payment_method() {
    if (this.supplier_inv_model['amount'] != '' && this.supplier_inv_model['amount'] != '0') {

      let dialog_data = {
        'total_amount': this.model['final_total'], 'payment_methods': this.dp1,
        'all_payment_types': this.all_payment_types
      };
      this.payDialogRef = this.dialog.open(SuppInvPaymentMethodComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.payDialogRef
        .afterClosed()
        .subscribe(result => {
          if (result['payment_methods'] != undefined && Array.isArray(result['payment_methods'])) {
            let cash_existed = false;
            let credit_existed = false;
            let bank_existed = false;

            result['payment_methods'].forEach(element => {
              if (element.payment_type_key == 'cash')
                cash_existed = true;
              if (element.payment_type_key == 'credit')
                credit_existed = true;
              else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
                bank_existed = true;
            });

            if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account') {
              document.getElementById('tr_cash').style.display = (cash_existed ? '' : 'none');
              document.getElementById('tr_cash2').style.display = (cash_existed ? '' : 'none');
            }
            document.getElementById('tr_payment_date').style.display = (credit_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct').style.display = (bank_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct2').style.display = (bank_existed ? 'table-row' : 'none');
            this.supplier_inv_model['is_paid'] = (credit_existed ? '0' : '1');

            this.dp1 = result['payment_methods'];
            this.dataSource2 = new MatTableDataSource(this.dp1);
            this.dataSource2.sort = this.sort;
            this.total_entered = this.dp1['0']['total_entered'];
          
            if (result['all_payment_types'] != undefined && Array.isArray(result['all_payment_types']))
              this.all_payment_types = result['all_payment_types'];
            console.log(this.all_payment_types);
          }
        });
    }
    else
      alert(this.Count_Price_Msg);
  }


  saveInvoice(save_type) {
    this.saveClicked = true;

    if (this.supplier_inv_model['supplier_invoice_no'] == '') {
      alert(this.Invoice_No_Msg);
      (document.getElementById('supplier_invoice_no') as HTMLInputElement).focus();
      this.saveClicked = false;
      return;
    }

    if (this.supplier_inv_model['supplier_no'] == '') {
      alert(this.Supplier_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.supplier_inv_model['is_paid'] == '0' && this.model['is_cc'] == '0') {
      alert(this.Supplier_Cc_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.dp.length == 0) {
      alert(this.One_Item_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.supplier_inv_model['amount'] == '' || Number(this.supplier_inv_model['amount']) == 0) {
      alert(this.Count_Price_Msg);
      this.saveClicked = false;
      return;
    }

    let element;
    if (this.supplier_inv_model['invoice_type'] == 'general') {
      let has_sub_item = true;
      let sub_item_name, sub_item_count;

      for (let index = 0; index < this.dp.length; index++) {
        element = this.dp[index];
        sub_item_name = (document.getElementById('general_sub_item_name_' + element.id) as HTMLInputElement).value;
        sub_item_count = (document.getElementById('general_sub_item_count_' + element.id) as HTMLInputElement).value;

        if (sub_item_name == '' && Number(sub_item_count) > 0) {
          has_sub_item = false;
          break;
        }
      }

      if (!has_sub_item) {
        alert(this.No_Item_Name_Msg);
        this.saveClicked = false;
        return;
      }
    }
    else if (this.supplier_inv_model['invoice_type'] == 'stock') {
      let hasStore = true;
      let hasExpiry = true;

      let storeId, expiryDate;
      
      for (let index = 0; index < this.dp.length; index++) {
        element = this.dp[index];
        storeId = (document.getElementById('store_id_' + element.id) as HTMLInputElement).value;
        expiryDate = (document.getElementById('expiry_date_d_' + element.id) as HTMLInputElement).value;
        console.log(storeId);
        if (storeId == '0' || storeId == '')
          hasStore = false;

        if (hasStore && element.is_expire == '1' && expiryDate == '')
          hasExpiry = false;

        if (!hasStore || !hasExpiry)
          break;
      }

      if (!hasStore) {
        alert(this.No_Store_Msg + (document.getElementById('sub_item_no_' + element.id) as HTMLInputElement).value);
        this.saveClicked = false;
        return;
      }

      if (!hasExpiry) {
        alert(this.Expiry_Date_Msg + (document.getElementById('sub_item_no_' + element.id) as HTMLInputElement).value);
        this.saveClicked = false;
        return;
      }
    }

    if (this.dp1.length == 0) {
      alert(this.Pay_Msg);
      this.saveClicked = false;
      return;
    }

    let is_cash = false;
    let is_bank = false;
    this.dp1.forEach(element => {
      if (element.payment_type_key == 'cash')
        is_cash = true;
      else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
        is_bank = true;
    });

    if ((this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account') && 
      is_cash && this.model['cash_acct_number'] == '0') {
      alert(this.Casher_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.applicationConstants.user_info.role != 'admin' && this.applicationConstants.user_info.role != 'account' && 
      is_cash && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      this.saveClicked = false;
      return;
    }

    if (is_bank && this.model['bank_acct_number'] == '0') {
      alert(this.Bank_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    let obj;
    let query = "SELECT `supplier_invoice_id` FROM `supplier_invoice` WHERE `supplier_invoice_no` = '" +
      this.supplier_inv_model['supplier_invoice_no'] + "' AND `supplier_no` = '" +
      this.supplier_inv_model['supplier_no'] + "' AND `status` != '0'";

    if (this.supplier_inv_model['supplier_invoice_id'] != '0')
      query += " AND `supplier_invoice_id` != '" + this.supplier_inv_model['supplier_invoice_id'] + "'";
    console.log(query);
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];
        if (result.length > 0) {
          alert(this.Inv_No_Exist_Msg);
          (document.getElementById('supplier_invoice_no') as HTMLInputElement).focus();
          this.saveClicked = false;
          return;
        }
        else {
          let values = [];

          ///////////////////// supplier_invoice //////////////////////

          this.supplier_inv_model['invoice_date'] = this.model['invoice_date_d'].getFullYear() + "-" +
            (this.model['invoice_date_d'].getMonth() + 1) + "-" + this.model['invoice_date_d'].getDate()
            + ' ' + new Date().getHours() + ':' + new Date().getMinutes() +
            ':' + new Date().getSeconds();
          this.supplier_inv_model['payment_date'] = (this.model['payment_date_d'].getFullYear() + "-" +
            (this.model['payment_date_d'].getMonth() + 1) + "-" + this.model['payment_date_d'].getDate());

          if (this.dp1.length == 1) {
            if (this.dp1[0].payment_type_key == 'credit')
              this.supplier_inv_model['acct_number'] = this.supplier_inv_model['supplier_no'];
            else if (this.dp1[0].payment_type_key == 'cash') {
              if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account')
                this.supplier_inv_model['acct_number'] = this.model['cash_acct_number'];
              else 
                this.supplier_inv_model['acct_number'] = this.applicationConstants.user_info['acct_number'];
            }
            else if (this.dp1[0].payment_type_key == 'bank' || this.dp1[0].payment_type_key == 'visa')
              this.supplier_inv_model['acct_number'] = this.model['bank_acct_number'];

            this.supplier_inv_model['payment_method'] = this.dp1[0].payment_type_key;
          }
          else {
            this.supplier_inv_model['acct_number'] = '0';
            this.supplier_inv_model['payment_method'] = '';
          }

          if (this.supplier_inv_model['transport_fee'] == '')
            this.supplier_inv_model['transport_fee'] = '0';

          if (this.supplier_inv_model['received'] != '1') {
            // this.supplier_inv_model['received'] = '2';

            this.supplier_inv_model['receipt_date'] = this.model['receipt_date_d'].getFullYear() + "-" +
              (this.model['receipt_date_d'].getMonth() + 1) + "-" + this.model['receipt_date_d'].getDate() + ' ' +
              new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();
          }
          else
            this.supplier_inv_model['receipt_date'] = this.supplier_inv_model['invoice_date'];


          let first_tax_acct = this.dp['0']['tax_no'];
          let first_purch_acct = this.dp['0']['expense_acct_no'];

          let is_equal_tax = true;
          let is_equal_purch_acct = true;
          this.dp.forEach(element => {
            if (element.tax_no != first_tax_acct)
              is_equal_tax = false;

            if (this.supplier_inv_model['invoice_type'] == 'stock') {
              if (element.expense_acct_no != first_purch_acct)
                is_equal_purch_acct = false;
            }
          });

          if (is_equal_tax)
            this.supplier_inv_model['tax_acct'] = first_tax_acct;

          if (this.supplier_inv_model['invoice_type'] == 'general')
            this.supplier_inv_model['purch_acct'] = this.exp_acct;
          else if (is_equal_purch_acct)
            this.supplier_inv_model['purch_acct'] = first_purch_acct;

          if (this.type == 'copy')
            this.supplier_inv_model['flag'] = 'new';

          values.push(this.supplier_inv_model);

          ///////////////////// supplier_invoice_item ////////////////////// 
          let stock_obj = { cmd: 'getStockNoList', sub_item_list: this.dp };
          this.utils.invokeHttp(this.applicationConstants.saleFuncFile, stock_obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let stock_no_list = data.data['list'][0];

              let id, sub_item_name, unit_id, sub_item_count, unit_price, discount, tax_no, store_id,
                expiry_date_d, expiry_date, sub_item_no;
              let type = this.supplier_inv_model['invoice_type'] + "_";
              let stock_exist, stock_base_exist;
              let quantity, cost_per_unit, baseline_amount;

              this.dp.forEach(element => {

                id = element['id'];
                sub_item_count = (document.getElementById(type + 'sub_item_count_' + id) as HTMLInputElement).value;

                if (sub_item_count != '' && Number(sub_item_count) > 0) {
                  unit_price = (document.getElementById(type + 'unit_price_' + id) as HTMLInputElement).value;
                  discount = (document.getElementById(type + 'discount_' + id) as HTMLInputElement).value;
                  tax_no = (document.getElementById(type + 'tax_no_' + id) as HTMLInputElement).value;

                  if (this.supplier_inv_model['invoice_type'] == 'stock') {
                    stock_exist = false;
                    stock_base_exist = false;

                    sub_item_no = (document.getElementById('sub_item_no_' + id) as HTMLInputElement).value;
                    store_id = (document.getElementById('store_id_' + id) as HTMLInputElement).value;
                    expiry_date_d = (document.getElementById('expiry_date_d_' + id) as HTMLInputElement).value;

                    //////////////////// supplier_invoice_item //////////////////////
                    values.push({
                      'table_name': 'supplier_invoice_item', 'supplier_invoice_item_id': (this.type == 'copy' ? '0' : element.supplier_invoice_item_id),
                      'invoice_no': this.supplier_inv_model['invoice_no'], 'sub_item_number': element.sub_item_number,
                      'sub_item_name': element.sub_item_name, 'unit_id': element.unit_id, 
                      'stock_no': (element.flag == 'new' ? stock_no_list[element.sub_item_number]: element.stock_no),
                      'branch_id': this.supplier_inv_model['branch_id'],
                      'count': sub_item_count, 'price': unit_price, 'store_id': store_id,
                      'total_price': element.total_price, 'tax_no': tax_no, 'tax_amount': element.tax_amount,
                      'discount': (discount != '' ? discount : '0'), 'primary_sub_item_number': element.primary_sub_item_number,
                      'primary_quantity': (Number(sub_item_count) * Number(element.primary_quantity)).toFixed(2),
                      'flag': (this.type == 'copy' ? 'new' : element.flag), 'key': element.key, 'comment': '', 'invoice_date': this.supplier_inv_model['invoice_date'],
                      'expense_acct_no': element.expense_acct_no

                    });

                    if (expiry_date_d != '') {
                      expiry_date = new Date(expiry_date_d);
                      expiry_date = (expiry_date.getFullYear() + "-" + (expiry_date.getMonth() + 1) + "-" +
                        expiry_date.getDate());

                      values[values.length - 1]['expiry_date'] = expiry_date;
                    }

                    //////////////////// stock ////////////////////// 
                    values.forEach(element1 => {
                      if (element1.table_name == 'stock' && element1.sub_item_number == element.primary_sub_item_number &&
                        (element1.expiry_date == undefined || element1.expiry_date == expiry_date)) {

                        quantity = Number(sub_item_count) * Number(element.primary_quantity);
                        element1.quantity = (Number(element1.quantity) + quantity).toFixed(2);
                        stock_exist = true;
                      }
                    });

                    if (!stock_exist) {
                      values.push({
                        'table_name': 'stock', 'stock_no': (element.flag == 'new' ? stock_no_list[element.sub_item_number]: element.stock_no), 'store_id': store_id,
                        'sub_item_number': element.primary_sub_item_number, 'stock_date': this.supplier_inv_model['invoice_date'],
                        'quantity': (Number(sub_item_count) * Number(element.primary_quantity)).toFixed(2),
                        'flag': (this.type == 'copy' ? 'new' : element.flag), 'key': 'stock_id', 
                        'stock_id': (this.type == 'copy' ? '0' : element.stock_id),
                        'invoice_no': this.supplier_inv_model['invoice_no'], 
                        'from_sub_item_number': element.sub_item_number, 'from_quantity': sub_item_count
                      });

                      if (expiry_date_d != '')
                        values[values.length - 1]['expiry_date'] = expiry_date;
                    }

                    //////////////////// stock_base ////////////////////// 
                    values.forEach(element1 => {
                      if (element1.table_name == 'stock_base' && element1.sub_item_number == element.primary_sub_item_number &&
                        (element1.expiry_date == undefined || element1.expiry_date == expiry_date)) {

                        let cost_per_unit = (((Number(element.total_price) - Number(discount)) / Number(sub_item_count)) / Number(element.primary_quantity));
                        element1.cost_per_unit = ((Number(element1.cost_per_unit) + cost_per_unit) / 2).toFixed(2);
                        let baseline_amount = (Number(sub_item_count) * Number(element.primary_quantity));
                        element1.baseline_amount = (Number(element1.baseline_amount) + baseline_amount).toFixed(2);
                        stock_base_exist = true;
                      }

                    });
                    if (!stock_base_exist) {
                      values.push({
                        'table_name': 'stock_base', 'sub_item_number': element.primary_sub_item_number,
                        'stock_no': (element.flag == 'new' ? stock_no_list[element.sub_item_number]: element.stock_no), 
                        'base_date': this.supplier_inv_model['invoice_date'], 'reason': '',
                        'store_id': store_id, 'is_manual': '2', 'source': 'supplier_invoice_item',
                        'baseline_amount': (Number(sub_item_count) * Number(element.primary_quantity)).toFixed(2),
                        'book_qty': '0', 'flag': (this.type == 'copy' ? 'new' : element.flag), 'key': 'baseline_id', 'baseline_id': (this.type == 'copy' ? '0' : element.baseline_id),
                        'cost_per_unit': (((Number(element.total_price) - Number(discount)) / Number(sub_item_count)) / Number(element.primary_quantity)).toFixed(2),
                        'invoice_no': this.supplier_inv_model['invoice_no']
                      });

                      if (expiry_date_d != '')
                        values[values.length - 1]['expiry_date'] = expiry_date;
                    }

                  }
                  else {
                    sub_item_name = (document.getElementById(type + 'sub_item_name_' + id) as HTMLInputElement).value;
                    unit_id = (document.getElementById(type + 'unit_id_' + id) as HTMLInputElement).value;

                    values.push({
                      'table_name': 'supplier_invoice_item', 'supplier_invoice_item_id': element.supplier_invoice_item_id,
                      'invoice_no': this.supplier_inv_model['invoice_no'], 'sub_item_number': '0',
                      'sub_item_name': sub_item_name, 'unit_id': unit_id, 'stock_no': '0',
                      'branch_id': this.supplier_inv_model['branch_id'],
                      'count': sub_item_count, 'price': unit_price, 'total_price': element.total_price, 'tax_no': tax_no,
                      'tax_amount': element.tax_amount, 'discount': (discount != '' ? discount : '0'), 'comment': '',
                      'flag': (this.type == 'copy' ? 'new' : element.flag), key: element.key, 'invoice_date': this.supplier_inv_model['invoice_date'],
                      'expense_acct_no': element.expense_acct_no
                    });
                  }
                }
              });

              ///////////////////// supp_inv_payment_method //////////////////////
              let acct_number = '';
              let supp_inv_payment_method_id;

              this.all_payment_types.forEach(element1 => {
                if (element1.flag != '') {
                  if (element1.payment_type_key == 'cash') {
                    if (this.applicationConstants.user_info.role == 'admin' || this.applicationConstants.user_info.role == 'account')
                      acct_number = this.model['cash_acct_number'];
                    else 
                      acct_number = this.applicationConstants.user_info['acct_number'];
                  }
                  else if (element1.payment_type_key == 'credit')
                    acct_number = this.supplier_inv_model['supplier_no'];
                  else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
                    acct_number = this.model['bank_acct_number'];

                  supp_inv_payment_method_id = element1.inv_payment_method_id;
                  if (supp_inv_payment_method_id == '' || supp_inv_payment_method_id == null ||
                    supp_inv_payment_method_id == undefined || supp_inv_payment_method_id == 'undefined')
                    supp_inv_payment_method_id = '0';

                  if (element1.amount == '')
                    element1.amount = '0';

                  values.push({
                    'table_name': 'supp_inv_payment_method', 'invoice_no': this.supplier_inv_model['invoice_no'],
                    'supp_inv_payment_method_id': (this.type == 'copy' ? '0' : supp_inv_payment_method_id), 'flag': (this.type == 'copy' ? 'new' : element1.flag),
                    'key': 'supp_inv_payment_method_id', 'payment_type_id': element1.payment_type_id,
                    'acct_number': acct_number, 'amount': element1.amount
                  });
                }
              });

              /////////////////////////////////////////////////////////////

              if (this.supplier_inv_model['flag'] == 'update') {
                ////////////////////////// DELETE //////////////////////////
                this.toDelete.forEach(delElem => {
                  if (delElem.key == 'supplier_invoice_item_id') {
                    values.push({
                      'table_name': 'supplier_invoice_item', 'key': 'supplier_invoice_item_id', 'flag': 'delete',
                      'supplier_invoice_item_id': delElem.supplier_invoice_item_id

                    });
                    if (this.supplier_inv_model['invoice_type'] == 'stock') {
                      stock_exist = false;
                      stock_base_exist = false;

                      values.forEach(element1 => {
                        if (element1.table_name == 'stock' && element1.flag == 'update' &&
                          element1.sub_item_number == delElem.primary_sub_item_number &&
                          (element1.expiry_date == undefined || element1.expiry_date == expiry_date)) {

                          stock_exist = true;
                        }
                      });
                      if (!stock_exist) {
                        values.push({
                          'table_name': 'stock', 'key': 'stock_id', 'flag': 'delete', 'stock_id': delElem.stock_id
                        });
                      }

                      values.forEach(element1 => {
                        if (element1.table_name == 'stock_base' && element1.flag == 'update' &&
                          element1.sub_item_number == delElem.primary_sub_item_number &&
                          (element1.expiry_date == undefined || element1.expiry_date == expiry_date)) {

                          stock_base_exist = true;
                        }

                      });
                      if (!stock_base_exist) {
                        values.push({
                          'table_name': 'stock_base', 'key': 'baseline_id', 'flag': 'delete', 'baseline_id': delElem.baseline_id
                        });
                      }

                    }
                  }
                });

                ////////////////////////// Check if there is any stock or stock base not used any more and not deleted //////////////////////////
                if (this.supplier_inv_model['invoice_type'] == 'stock') {
                  this.dp.forEach(element => {
                    stock_exist = false;
                    stock_base_exist = false;

                    values.forEach(element1 => {
                      if (element1.table_name == 'stock' && (element1.flag == 'update' || element1.flag == 'delete') &&
                        element1.stock_id == element.stock_id) {

                        stock_exist = true;
                      }
                    });
                    if (!stock_exist) {
                      values.push({
                        'table_name': 'stock', 'key': 'stock_id', 'flag': 'delete', 'stock_id': element.stock_id
                      });
                    }

                    values.forEach(element1 => {
                      if (element1.table_name == 'stock_base' && (element1.flag == 'update' || element1.flag == 'delete') &&
                        element1.baseline_id == element.baseline_id) {

                        stock_base_exist = true;
                      }

                    });
                    if (!stock_base_exist) {
                      values.push({
                        'table_name': 'stock_base', 'key': 'baseline_id', 'flag': 'delete', 'baseline_id': element.baseline_id
                      });
                    }
                  });
                }

                obj = { cmd: 'updateAdv', values: values };
              }
              else {
                let year = this.model['invoice_date_d'].getFullYear();
                let prefix = this.applicationConstants.user_branch_info.user_branch_id + "-" + year +
                  this.supplier_inv_model['supplier_invoice_no'];
                obj = {
                  cmd: 'add', values: values, pk: 'invoice_no', id: 'supplier_invoice_id',
                  main_table: 'supplier_invoice', prefix: prefix
                };
              }

              console.log(values);
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    let invoice_no = '';
                    if (this.supplier_inv_model['flag'] == 'update') {
                      invoice_no = this.supplier_inv_model['invoice_no'];

                      // check if total has changed and there is cash receipt for this invoice, then fix the remaining
                      if (this.model['has_voucher'] == 1 && this.model['old_final_total'] != (Number(this.model['final_total']) + Number(this.supplier_inv_model['transport_fee']))) {

                        obj = {
                          cmd: 'updatePaymentVoucher', invoice_no: invoice_no,
                          old_invoice_total: this.model['old_final_total']
                        };

                        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
                          .subscribe(data => {
                            this.applicationConstants.appComp.hideBusyCursor();

                            if (data.status['type'] == 'error')
                              alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
                            
                            alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);

                          });
                      }
                      else
                        alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
                    }
                    else {
                      invoice_no = data.status['msg'][0]['number'];
                      alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
                    }

                    if (save_type == 'print')
                      window.open(this.applicationConstants.generatePDF + "?type=supplier_invoice&no=" + invoice_no, "_blank");

                    this.router.navigate(['sub_menu/7/supplier_invoice_list']);
                  }
                  else {
                    alert(this.Error_Msg);
                    this.saveClicked = false;
                  }
                });
            });

        }
      });

  }

}
